// Global Imports
import * as React from "react";
// Controls
import { IconIndicator } from "./IconIndicator";
// Style
import { useTheme } from "@fluentui/react";
import { checklistSmallIconProps } from "../../../icons/icons.styles";
import { getBaseIndicatorStyles } from "./Indicators.styles";
// Utilities
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
import * as StringHelper from "@fluentui/utilities";
/**
 * Checklist Indicator component that renders an icon indicating a checklist exists on the task
 */ export const ChecklistIndicator = (props)=>{
    const numChecklistItems = Math.max(props.numChecklistItems, 0);
    const numCompletedChecklistItems = Math.max(props.numCompletedChecklistItems, 0);
    const checklistIndicatorAriaLabel = StringHelper.format(Strings.ChecklistIndicator_ChecklistIndicatorAriaLabel, numCompletedChecklistItems, numChecklistItems);
    const indicatorLabel = StringHelper.format(Strings.TaskEditor_ChecklistFraction, numCompletedChecklistItems, numChecklistItems);
    const theme = useTheme();
    const styles = getBaseIndicatorStyles(theme);
    return /*#__PURE__*/ React.createElement("div", {
        className: "checkList indicator",
        title: checklistIndicatorAriaLabel
    }, /*#__PURE__*/ React.createElement(IconIndicator, {
        ...props,
        ariaLabel: checklistIndicatorAriaLabel,
        label: indicatorLabel,
        iconProps: checklistSmallIconProps,
        styles: styles
    }));
};
